import React, { FunctionComponent } from 'react'
import { FormattedMessage, injectIntl, InjectedIntlProps } from 'react-intl'
import { Price } from 'src/components/calendar/BuyTickets/Price'
import { TicketButton } from 'src/components/calendar/BuyTickets/TicketButton'
import { shouldShowFanReminderData, FanReminderInfo } from './FanReminderInfo'
import locale from '../locale'
const style = require('./TicketNav.css')

interface Props {
  eventData: any;
  viewer: any;
  baseUrl: string;
  listingStatus: string;
  ticketButtonText: string;
  isTimedEntry: boolean;
  eventOpen: boolean;
  expanded: boolean;
  loading: boolean;
  eventSoldOut: boolean;
}

export const TicketNavComponent: FunctionComponent<
  Props & InjectedIntlProps
> = ({
  eventData,
  baseUrl,
  loading,
  viewer,
  listingStatus,
  ticketButtonText,
  isTimedEntry,
  intl,
}) => {
  const hasFanReminder = shouldShowFanReminderData(listingStatus);
  if (loading) return null

  const showPriceText = (
    (eventData.minPrice !== null) || (eventData.maxPrice !== null)) && (listingStatus === 'availableStandard'
  )

  const orderFeeApplicable = eventData.orderFeeApplicable;
  const orderFeeDisclaimerAmount = intl.formatNumber(eventData.orderFeeDisclaimerAmount, {
    style: 'currency',
    currency: eventData.transactionCurrency
  })

  return (
    <div className={style.container}>
      <div className={style.header}>
        <div className={style.price}>
          <div>
            {showPriceText && intl.formatMessage(locale.price)}
          </div>
          <Price
            minPrice={eventData.minPrice}
            maxPrice={eventData.maxPrice}
            currency={eventData.transactionCurrency}
            listingStatus={listingStatus}
          />
        </div>
        {orderFeeApplicable && (
          <div className={style.orderFeeDisclaimer}>
            <FormattedMessage
              id="ticketWidget.orderFeeDisclaimer"
              defaultMessage="Additional fees of {amount} will be added to each paid order"
              values={{
                amount: <b>{orderFeeDisclaimerAmount}</b>
              }}
            />
          </div>
        )}
      </div>
      <div className={style.content}>
        {hasFanReminder ? (
          <FanReminderInfo
            listingStatus={listingStatus}
            fanReminderEndStamp={eventData.fanReminderEndStamp}
            timezone={eventData.timezone}
            cta={
              <TicketButton
                listingStatus={listingStatus}
                ticketButtonText={ticketButtonText}
                isTimedEntry={isTimedEntry}
                eventId={eventData.id}
                baseUrl={baseUrl}
                hostId={eventData.hostId}
                viewer={viewer}
              />
            }
          />
        ) : (
          <TicketButton
            listingStatus={listingStatus}
            ticketButtonText={ticketButtonText}
            isTimedEntry={isTimedEntry}
            eventId={eventData.id}
            baseUrl={baseUrl}
            hostId={eventData.hostId}
            viewer={viewer}
          />
        )}
      </div>
    </div>
  )
}

export const TicketNav = injectIntl(TicketNavComponent)
